import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"

export const PropertyAssetAttributes_s = styled.div`
  #search-bar {
    margin-top: 8px;
  }
`